module.exports = __webpack_public_path__ + "static/media/messy-paper-dark.7a7ba291.png";